module.exports = __webpack_public_path__ + "static/media/Medical_Support.d2e00459.mp3";